import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, getContext } from 'recompose';
import { createScriptElement, createStylesheetElement } from 'utils/dom/dom';

export const enhance = compose(
	getContext(),
	lifecycle({
		componentDidMount() {
			const {
				id, scriptURL, stylesheetURL, onLoad, onError
			} = this.props;

			
			const handleOnLoad = () => {
				// Build a config, inheriting the local config + any passed in properties
				if (onLoad) onLoad();
			};

			const handleOnError = () => {
				if (onError) onError();
			};

			if (stylesheetURL) {
				const linkEl = createStylesheetElement({
					id: `${id}-stylesheet`,
					href: stylesheetURL
				});

				document.head.appendChild(linkEl);

			} else {
				return handleOnError();
			}

			const scriptEl = createScriptElement({
				id,
				src: scriptURL,
				onload: handleOnLoad,
				onerror: handleOnError,
				async: true,
				crossorigin: 'anonymous'
			});
			document.body.appendChild(scriptEl);
		}
	})
);

export const MicroFrontEndEmbed = ({ id, className, data }) => (
	<div className={className} id={id} {...data} />
);

MicroFrontEndEmbed.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string,
	data: PropTypes.object
};



export default enhance(MicroFrontEndEmbed);
